<template>
  <div>
    <div style="display: flex; margin-bottom: 20px; margin-left: 40px">
      <el-page-header @back="back" content="打印入库单" style="margin-right: 20px"></el-page-header>
      <button type="primary" @click="printContext">打印</button>
    </div>
    <div id="printMe" ref="print">
      <div class="printtable" style="page-break-after:always;">
        <div class="table_title">
          <img src="@/assets/images/jflogo.png" alt="" style="height:25px;position:absolute;left:25px;">
          {{ organizationName }}(入库单)
        </div>
        <!-- 打印 -->
        <div>
          <div class="AMarkUl">
            <ul>
              <li>入库单号:{{ ATableData.instockNo }}</li>
              <li>一级货主:{{ ATableData.primaryCustomerName }}</li>
              <li>二级货主:{{ ATableData.customerName }}</li>
            </ul>
            <ul>
              <li style="font-size:22px;font-weight: 700;">车号:{{ ATableData.instockPlateNumber }}</li>
              <li>车船号:{{ ATableData.plateNumber }}</li>
              <li>预报编号:{{ ATableData.shipForecastNo }}</li>
            </ul>
          </div>
          <table style="word-break:break-all;word-wrap:break-all;">
            <tbody>
              <tr>
                <td class="kunbao" style="">产地</td>
                <td class="kunbao" style="min-width:75px">货物类型</td>
                <td class="kunbao">规格</td>
                <td class="kunbao">材质</td>
                <td class="kunbao">件数</td>
                <td class="kunbao">总重量(吨)</td>
                <td class="kunbao">毛重(吨)</td>
                <td class="kunbao">皮重(吨)</td>
                <td class="kunbao">净重(吨)</td>
              </tr>
              <tr v-for="(item, index) in ATableList" :key="index">
                <td>{{ item.steelMillName }}</td>
                <td>{{ item.productTypeName }}</td>
                <td>{{ item.specification }}</td>
                <td>{{ item.model }}</td>
                <td>{{ item.number }}</td>
                <td>{{ Number(item.allWeight).toFixed(4) }}</td>
                <td>{{ Number(item.grossWeight).toFixed(4) }}</td>
                <td>{{ Number(item.tareWeight).toFixed(4) }}</td>
                <td>{{ Number(item.weighingWeight).toFixed(4) }}</td>
              </tr>
              <tr>
                <td>合计</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ numberSum }}</td>
                <td>{{ weightSum }}</td>
                <td>{{ }}</td>
                <td>{{ }}</td>
                <td>{{ }}</td>
              </tr>
              <tr>
                <td>备注</td>
                <td colspan='8' style="text-align:left">{{ ATableData.ext1 }}</td>
              </tr>
            </tbody>
          </table>
          <div class="AMarkFoot">
            <ul>
              <li>司磅员:{{ ATableData.createUser }}</li>
              <li>司机签字：</li>
              <li>打印时间:{{ datenow }}</li>
            </ul>
          </div>
          <div class="remarks">
            {{ showname }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  JfgetThreadExpList,
  getInstockSummaryList
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'
import { getDictionaryList } from '@/api/wms-stock'

export default {
  data() {
    return {
      weightSum: 0,
      numberSum: 0,
      totalNum: 0,
      totalWeightDouble: 0,
      id: '',
      idAll: '',
      type: 0,
      getData: null,
      flag: 0,
      getFlag: false,
      ATableList: [], // 表格
      ATableData: [], // 信息
      datenow: '',
      showname: '本单壹式贰联：第一联单证中心，第二联保管员',
      organizationName: window.localStorage.getItem('tenantName')
    }
  },
  created() {
    // 生命周期里接收参数
    this.id = this.$route.query.id // 接受参数关键代码
    this.JfgetThreadExpLists()
    this.getInstockSummaryLists()
    // this.getDictionaryLists()
    this.datenow = dateFormat1(new Date().getTime(), 'CHN-YYYY-MM-ss h-m-s')
  },
  mounted() {
  },
  methods: {
    // 主表
    JfgetThreadExpLists() {
      JfgetThreadExpList({
        instockId: this.id
      })
        .then(res => {
          console.log(res)
          this.ATableData = res[0]
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }, 
    // 货物详情
    getInstockSummaryLists() {
      getInstockSummaryList({
        instockId: this.id
      })
        .then(res => {
          console.log(res)
          this.ATableList = res
          this.weightSum = res.reduce((pre, cur) => Number(pre / 1 + cur.allWeight / 1).toFixed(4), 0)
          this.numberSum = res.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
          res.forEach(item => {
            if (!item.grossWeight) {
              item.grossWeight = 0.0000
            }
            if (!item.tareWeight) {
              item.tareWeight = 0.0000
            }
            if (!item.weighingWeight) {
              item.weighingWeight = 0.0000
            }
          });

        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 打印内容
    printContext() {
      this.$print(this.$refs.print)
    },
    // 点击返回上一步
    back() {
      this.$router.go(-1) // 返回上一层
    },
    getDictionaryLists() {
      getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'in_empty_remark' })
        .then(res => {
          console.log(res)
          this.showname = res[0].showName
        })
        .catch(err => {
          this.message({ message: err.message, type: 'error' })
        })
    }
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      // let s = date.getSeconds()
      // s = s <script 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  }
}
</script>

<style scoped lang='less'>
button {
  width: 100px !important;
}

#printMe {
  font-size: 19px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  border: 1px solid #ccc;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 29px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}

.printtable {
  width: 900px;
  margin-bottom: 20px;
}

.AMarkUl {
  // font-size: 12px !important;
  width: 100%;
  font-size: 17px;

  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;

    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}

.AMarkFoot {
  font-size: 17px;
  bottom: 10px;
  width: 100%;

  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;

    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}

table,
th,
td {
  border: 1px solid blue;
}

table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}

table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 22px;

  td {
    // width: 17%;
    // padding: 4px 4px;
    text-align: center;
    height: 24px;
  }

  .kunbao {
    font-weight: 600;
  }
}

.remarks {
  font-size: 17px;
  text-align: center;

  p {
    margin: 0;
    padding: 0;
  }
}
</style>
